module.exports = __webpack_public_path__ + "img/horizontal_6_3_9005.55d33788.png";